import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=4ca90dc5&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=ts&"
export * from "./NewsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./NewsDetails.vue?vue&type=style&index=0&id=4ca90dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca90dc5",
  null
  
)

export default component.exports